/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { Iceutility } from '../../services/iceutility';
import { alert } from '../system/alert';

export interface IIceEntity {
    gettablename(): string;
    getsubtreedata(SubColumnName: string, ColumnName: string, Value: string): any;
    hassubtree(ColumnName: string): boolean;
    getsubtreetablename(ColumnName: string): string;
}

export class IceEntity implements IIceEntity {
  ALERTS: alert[] = [];

    constructor() {

    }

    gettablename(): string {
        return "";
    }

    getsubtreedata(SubColumnName: string, ColumnName: string, Value: string): any {
        return this.getsubtreeobject(this[SubColumnName], ColumnName, Value);
    }

    hassubtree(ColumnName: string): boolean {
        return false;
    }

    getsubtreetablename(ColumnName: string): string {
        return null;
    }

    getsubtreeobject(Ary: any[], ColumnName: string, Value: string): any {
      if (Ary == null || Ary.length == 0)
          return null;

      if (ColumnName == null || ColumnName.length == 0)
          return null;

      if (Value == null || Value.length == 0)
          return null;

      var obj = null;
      for (var i = 0; i < Ary.length; i++) {
          var tmp = Ary[i];
          if (tmp == null)
              continue;

          var tmpval = tmp[ColumnName.toLowerCase()];
          if (tmpval != null && tmpval.toLowerCase() == Value.toLowerCase()) {
              obj = tmp;
              break;
          }
      }
      return obj;
  }
  getStringValue(object: any, elem: string): string {
    if (object == null || elem == null || elem.length == 0 || object[elem] == null) return "";
    return object[elem];
  }
  getLongValue(object: any, elem: string): number {
    if (object == null || elem == null || elem.length == 0) return 0;
    return Iceutility.toLong(object[elem]);
  }
  getDoubleValue(object: any, elem: string): number {
    if (object == null || elem == null || elem.length == 0) return 0.0;
    return Iceutility.toDouble(object[elem]);
  }
  getBoolValue(object: any, elem: string): boolean {
    if (object == null || elem == null || elem.length == 0) return false;
    return Iceutility.toBoolean(object[elem]);
  }
  setStringValue(object: any, elem: string, val: any): void {
    if (object == null || elem == null || elem.length == 0) return;
    object[elem] = val;
  }
}
